export default __webpack_public_path__ + "static/media/icon3.594aa9a0.svg";